import * as React from "react";
import "../index.css";
import {
  GoogleIcon,
} from "../../../icons";
import { OutlinedInput } from "../../../Input";
import Menu from "../../Menu";
import { useDispatch } from "react-redux";
import {
  signUp,
  signInWithGoogle,
  signInWithFacebook
} from "../../../../features/auth/authSlice";
import { useLocation, useNavigate } from "react-router-dom";

const SignUpMenu = ({ onSignInClick, closeModal, setIsOpen, isOpen }) => {
  const navigate = useNavigate();
  let location = useLocation();

  const [signUpState, setSignUpState] = React.useState({
    email: "",
    password: "",
    confirmPassword: "",
    termsAccept: false,
  });

  const handleGoogleSignIn = async () => {
    dispatch(
      signInWithGoogle({
        onSuccess: () => {
          if (location.pathname === "/") {
            navigate("/dashboard");
          }
        },
      })
    );
  }

  const handleFacebookSignIn = async () => {
    dispatch(
      signInWithFacebook({
        onSuccess: () => {
          if (location.pathname === "/") {
            navigate("/dashboard");
          }
        },
      })
    );
  }

  const handleStateChange = (e) => {
    setSignUpState((val) => ({
      ...val,
      [e.target.name]: e.target.value,
    }));
  };

  const dispatch = useDispatch();

  return (
    <Menu setIsOpen={setIsOpen} isOpen={isOpen} onOverlayClick={closeModal}>
      <div className="auth-section container">
        <section title="Signup">
          <form
            className="auth-form"
            onSubmit={(e) => {
              dispatch(
                signUp({
                  email: signUpState.email,
                  password: signUpState.password,
                  firstName: signUpState.firstName,
                  lastName: signUpState.lastName,
                })
              );
              closeModal();
            }}
          >
            <h2>Create Account</h2>
            <OutlinedInput
              onChange={handleStateChange}
              name="firstName"
              title="First Name"
              value={signUpState.firstName}
              required
            />
            <OutlinedInput
              onChange={handleStateChange}
              name="lastName"
              title="Last Name"
              value={signUpState.lastName}
              required
            />
            <OutlinedInput
              onChange={handleStateChange}
              name="email"
              title="Email"
              value={signUpState.email}
              type="email"
              required
            />
            <OutlinedInput
              onChange={handleStateChange}
              name="password"
              title="Password"
              value={signUpState.password}
              type="password"
              required
              minLength={6}
            />
            <OutlinedInput
              onChange={handleStateChange}
              name="confirmPassword"
              title="Confirm Password"
              value={signUpState.confirmPassword}
              type="password"
              required
              pattern={signUpState.password}
              minLength={6}
            />
            <div className="terms">
              <input
                type={"checkbox"}
                value={signUpState.termsAccept}
                onChange={() => {
                  setSignUpState((val) => ({
                    ...val,
                    termsAccept: !val.termsAccept,
                  }));
                }}
                className="pointer"
                required
              />
              <span>
                By clicking Create account , You have acknowledge you have read
                and aggred to our&nbsp;
                <strong>Terms of use</strong>
              </span>
            </div>
            <div className={"auth-sign-wrapper"}>
              <button type="submit" className={"auth-sign-btn pointer"}>
                Sign up
              </button>
            </div>
            <div className="or-text">OR</div>
            <div className="auth-btn-group">
              <div className={"auth-btn"} onClick={() => handleGoogleSignIn()}>
                <GoogleIcon className={"auth-icon"} />
                Google
              </div>
              {/* <div className={"auth-btn"} onClick={() => handleFacebookSignIn}>
                <FacebookColorIcon className={"auth-icon"} />
                Facebook
              </div> */}
            </div>
            <span className="create-account">
              Already registered?&nbsp;
              <span
                onClick={() => {
                  closeModal();
                  onSignInClick();
                }}
                className="pointer"
              >
                <strong>Sign in</strong>
              </span>
            </span>
          </form>
        </section>
      </div>
    </Menu >
  );
};

export default SignUpMenu;
